<ts-generic-error
  ts-page-title
  error="page-not-found"
  navigation_title="{{ 'page_not_found' | translate }}"
/>
